"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVoyageMessage = void 0;
var EVoyageMessage;
(function (EVoyageMessage) {
    EVoyageMessage[EVoyageMessage["Cursor"] = 10] = "Cursor";
    EVoyageMessage[EVoyageMessage["CrewSelected"] = 11] = "CrewSelected";
    EVoyageMessage[EVoyageMessage["CrewMove"] = 12] = "CrewMove";
    EVoyageMessage[EVoyageMessage["CrewCreate"] = 13] = "CrewCreate";
    EVoyageMessage[EVoyageMessage["CrewHurt"] = 14] = "CrewHurt";
    EVoyageMessage[EVoyageMessage["BulletCreate"] = 15] = "BulletCreate";
    EVoyageMessage[EVoyageMessage["CrewCarry"] = 16] = "CrewCarry";
    EVoyageMessage[EVoyageMessage["CrewHurtEnergy"] = 17] = "CrewHurtEnergy";
    EVoyageMessage[EVoyageMessage["Jettison"] = 18] = "Jettison";
    EVoyageMessage[EVoyageMessage["CrewStyle"] = 19] = "CrewStyle";
    EVoyageMessage[EVoyageMessage["HostCommand"] = 100] = "HostCommand";
    EVoyageMessage[EVoyageMessage["EffectCommand"] = 101] = "EffectCommand";
    EVoyageMessage[EVoyageMessage["ShipStatus"] = 102] = "ShipStatus";
    EVoyageMessage[EVoyageMessage["EnemyShipCommand"] = 103] = "EnemyShipCommand";
    EVoyageMessage[EVoyageMessage["GeneralCommand"] = 104] = "GeneralCommand";
    EVoyageMessage[EVoyageMessage["InfoRequest"] = 105] = "InfoRequest";
    EVoyageMessage[EVoyageMessage["InfoSend"] = 106] = "InfoSend";
    EVoyageMessage[EVoyageMessage["WeaponCommand"] = 107] = "WeaponCommand";
    EVoyageMessage[EVoyageMessage["SystemCreate"] = 108] = "SystemCreate";
    EVoyageMessage[EVoyageMessage["BuyRequest"] = 109] = "BuyRequest";
    EVoyageMessage[EVoyageMessage["Jump"] = 110] = "Jump";
    EVoyageMessage[EVoyageMessage["Money"] = 111] = "Money";
    EVoyageMessage[EVoyageMessage["StarmapCreate"] = 112] = "StarmapCreate";
    EVoyageMessage[EVoyageMessage["RequestGamestate"] = 113] = "RequestGamestate";
    EVoyageMessage[EVoyageMessage["LoadShip"] = 114] = "LoadShip";
    // Need to redo command numbers
    EVoyageMessage[EVoyageMessage["Dive_GameSync"] = 20] = "Dive_GameSync";
    EVoyageMessage[EVoyageMessage["Dive_SimulationFrame"] = 21] = "Dive_SimulationFrame";
    EVoyageMessage[EVoyageMessage["Dive_LoadState"] = 22] = "Dive_LoadState";
    EVoyageMessage[EVoyageMessage["Dive_MouseInput"] = 23] = "Dive_MouseInput";
    EVoyageMessage[EVoyageMessage["Dive_SimulationSync"] = 24] = "Dive_SimulationSync";
    EVoyageMessage[EVoyageMessage["Dive_HostCommand"] = 25] = "Dive_HostCommand";
    EVoyageMessage[EVoyageMessage["Dive_AlterEntity"] = 26] = "Dive_AlterEntity";
    // TOOD: move to crokinole
    EVoyageMessage[EVoyageMessage["Crokinole_GameSync"] = 30] = "Crokinole_GameSync";
    EVoyageMessage[EVoyageMessage["Crokinole_SimulationFrame"] = 31] = "Crokinole_SimulationFrame";
    EVoyageMessage[EVoyageMessage["Crokinole_Input"] = 32] = "Crokinole_Input";
    EVoyageMessage[EVoyageMessage["Crokinole_FullSync"] = 33] = "Crokinole_FullSync";
    EVoyageMessage[EVoyageMessage["Crokinole_Cursor"] = 34] = "Crokinole_Cursor";
    EVoyageMessage[EVoyageMessage["Crokinole_GameDrift"] = 35] = "Crokinole_GameDrift";
})(EVoyageMessage = exports.EVoyageMessage || (exports.EVoyageMessage = {}));
